export const ROUTES = {
  HOME: '/',
  LOGIN: '/ingresar',
  DASHBOARD: '/inicio',
  POS: {
    CHECKOUT: '/caja',
  },
  SALES: {
    HISTORY: '/ventas/historial',
  },
  PRODUCTS: {
    CATALOG: '/productos/catalogo',
  },
  INVENTORY: {
    LOTS: '/inventario/lotes',
    MOVEMENTS: '/inventario/movimientos',
    INTAKE: '/inventario/entrada-stock',
    ADJUSTMENTS: '/inventario/ajuste-stock',
  },
  REPORTS: {
    STOCK: '/reportes/stock',
  },
  ADMIN: {
    USERS: '/administracion/usuarios',
    ROLES_PERMISSIONS: ROLES_PERMISSIONS_PATH,
    SETTINGS: '/administracion/configuracion',
    SETTINGS_APPEARANCE: '/administracion/configuracion/apariencia',
  },
} as const
import { ROLES_PERMISSIONS_PATH } from '@/features/roles-permissions/constants'
